import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {Organization} from "../types.ts";
import {useOrganization} from "../hooks/useOrganization.ts";


export const AddFormDrawer = (props: DrawerProps) => {

    const {
        record,
        createRecord,
    } = useOrganization();

    return (
        <FormDrawer
            record={record ?? {} as Organization}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
